import {
    DIC
} from '@/const/dic'
import {
    validateChinese
} from '@/util/validate'

export const ruleOption = {
    align: "center",
    menuAlign: "center",
    headerAlign: "center",
    border: true,
    expand: false,
    stripe: false,
    showHeader: true,
    // align: 'center',
    index: false,
    selection: true,
    menu: true,
    page: true,
    addBtn: false,
    editBtn: false,
    delBtn: false,
    viewBtn: true,
    menuWidth: '300',
    defaultSort: {
        prop: 'createTime',
        order: 'descending'
    },
    column: [{
        label: "升级规则名称",
        prop: "parameters",
        type: "input"
    },
        {
            label: "团队每单获得经验值",
            prop: "eachExperiencePoint",
            type: "input"
        }, {
            label: "规则时间范围",
            prop: "parameterValue",
            placeholder:"请输入规则时间范围默认单位天（例如：30）",
            type: "input"
        }, {
            label: "对比关系",
            prop: "correlation",
            type: "select",
            dicData: DIC.RULE_CONTRAST,
        },
        {
            label: "判定规则接单数设置",
            prop: "number",
            type: "input"
        },
        {
            label: "额外经验值奖励设置",
            prop: "extraExperiencePoint",
            type: "input"
        },
        {
            label: "状态",
            prop: "status",
            type: "input",
            solt: true,
            addVisdiplay: false,
            editVisdiplay: false
        }
    ]
};